import {client} from '../gql'
import {
  User_History_Bool_Exp,
  User_History_Insert_Input,
  User_History_Order_By,
  User_History_Select_Column,
  UserHistoryFragment,
} from '../graphqlSdk'
import {ServerError} from '../server/errors'
import {WithRequiredProp} from '../types'

const insertOne = async (
  object: WithRequiredProp<User_History_Insert_Input, 'email' | 'user_id' | 'created_by_user_id'>,
): Promise<UserHistoryFragment> => {
  const action = (await client.userHistoryInsertOne({object})).insert_user_history_one

  if (!action) {
    throw new ServerError('User history insertOne returned null', {object})
  }

  return action
}

const getMany = async (
  where: User_History_Bool_Exp,
  order_by?: User_History_Order_By,
  offset?: number,
  limit?: number,
  distinct_on?: User_History_Select_Column,
): Promise<UserHistoryFragment[]> =>
  (await client.userHistoryGetMany({where, order_by, offset, limit, distinct_on})).user_history

export const userHistoryOrm = {
  insertOne,
  getMany,
}
